/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BeEPLogo from '../../assets/images/BeEP-logo-noPadding.svg';
import './page-title.scss';
import {UiImg} from "@webfox-sc/core";

class PageTitle extends Component {
    // constructor(props) {
    //     super(props);
    // }

    handleOnClick(e) {
        e.preventDefault();
        const { onClick } = this.props;
        onClick('/');
    }

    render() {
        const { mobile } = this.props;
        const className = mobile ? 'bt-page-title bt-page-title--mobile' : 'bt-page-title';

        return (
            <a className={className} href="/" onClick={(e) => this.handleOnClick(e)}>
                <UiImg
                    src={BeEPLogo}
                    alt="Biotronik BeEP"
                    width={mobile ? "230px" : "90%"}
                    height="auto"
                    verticalAlign="top"
                />
            </a>
        );
    }
}

PageTitle.propTypes = {
    mobile: PropTypes.bool,
    onClick: PropTypes.func
};

PageTitle.defaultProps = {
    mobile: false,
    onClick: () => false
};

export default PageTitle;
